import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const PlayIcon = ({ color = 'black', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M1 15V1L11.4478 8L1 15Z" stroke={color} style={{ strokeMiterlimit: 10 }} />
    </svg>
  );
};

export default PlayIcon;
